import styled, { css } from "styled-components";

export const QueueContainer = styled.div`
  ${(props: { pageAssets?: any }) =>
    props.pageAssets && props.pageAssets.backgroundColor
      ? css`
          background: linear-gradient(
            180deg,
            ${props.pageAssets.backgroundColor} -18.72%,
            ${props.pageAssets.contrastColor || "#0a070f"} 75.27%
          );
        `
      : css`
          background: linear-gradient(180deg, #2c1050 -18.72%, #0a070f 75.27%);
        `}

  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  img {
    max-height: 80px;
    max-width: 200px;
    margin: 10% 0px -20%;
  }
`;

export const VideoContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 60vw;
  video {
    width: 80%;

    border-radius: 22px;
  }
  button {
    border: none;
    height: 50px;
    margin-top: 16px;
    width: 200px;
    border-radius: 20px;
    outline: none;
  }
  @media (max-width: 768px) {
    width: 90vw;
    video {
      width: 95%;
      min-width: 300px;
      height: auto;
      max-height: 525px;
      min-height: 250px;
      object-fit: fill;
    }
    button {
      justify-self: flex-end;
    }
  }
`;
